import { OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridMetaModel, Headers } from 'common/models/utility-models/meta-model';


export class TypesGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Type',
            ROUTE_PATH.typeGrid,
            ROUTE_PATH.addType,
            false,
            true,
            5,
            false,
            true,
            ['type_name'],
            false,
            [],
            {
                isDownloadExcel: false, excelFileName: '',
                btnLabel: '', headers: []
            },
            false,
            {},
            false,
            null,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            null,
            null,
            null,
            null,
            true,
            true,
            false,
            [],
            true,
            { isExtraActions: false, btnLabel: '', selectOptions: [] },
            { isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: '' },
            { isDownload: false, key: '', valueKey: '' },
            { isTabStatus: false, label: '', isChecked: false },
            false,
            false,


        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const name = new Headers('Name', 'type_name', false, true, 'text', '0',
            { isColumnNavigation: true, navigationUrl: ROUTE_PATH.addType, navigateOperationType: OperationType.UPDATE, navigateTransferData: new WidgetModel(), navigatePageName: "View Type" },
        );
        const cat = new Headers('No. of Categories', 'categoryCount', false, true, 'text');
        const status = new Headers('Status', 'isActive', false, false, 'toggle', '1', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: true, toggleKey: 'isActive', toggleCheckedValue: 1, toggleUncheckedValue: 0 });
        headers.push(name);
        headers.push(cat);
        headers.push(status);

        return headers;
    }
} 